//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStorage, setStorage } from "@/js/utils";
import { SUCCESS_CODE } from "@/service/httpCode";

export default {
    name: "supportBanks",
    data() {
        return {
            bankList: [],
            selectedBank: null,
            // 此页面做两用，一为支持银行，一位选择银行
            isBankSelectPage: false,
            isCreditReferer: false,
            isLoading: false,
        };
    },
    methods: {
        selectBank(bankName, bankID) {
            this.$store.selectedBank = bankID;
            this.$store.selectedBankName = bankName;
            this.$router.go(-1);
        },
    },
    created() {
        this.selectedBank = this.$store.selectedBank;
        this.isBankSelectPage = this.$route.query.isBankSelectPage === "1";
        // 从credit页面跳转过来
        this.isCreditReferer = this.$route.query.refererPage === "credit";

        if (this.isCreditReferer) {
            this.showTheLoading(async () => {
                const { result, data } = await this.$http.creditBankQuery();
                if (result === SUCCESS_CODE) {
                    this.bankList = data;
                }
            }, "isLoading");
        } else {
            this.bankList = getStorage("session", "banks");
        }

        this.$bus.$emit("update-title", {
            title: this.isBankSelectPage
                ? "选择银行"
                : this.isCreditReferer
                    ? "选择发卡银行"
                    : "支持银行",
            noClose: true,
            rightView: [],
        });
    },
};
